<template>
  <a class="nav-link" :href="url" target="_blank"><span v-if="isNew" class="badge badge-success">New!</span><span v-bind:class="newClass">{{text}}</span></a>
</template>

<script>
export default {
  name: 'nav-item',
  props: ['url', 'text', 'exact', 'isNew'],
  computed: {
    newClass () {
      return this.isNew ? 'new-text' : null
    }
  }
}
</script>

<style scoped>
.new-text {
  padding-left: 5px;
}

.nav-link {
  color: white !important;
}

.nav-link.active {
  font-weight: 600;
}
</style>
